export const MAX_CHALLENGES = 4
export const ALERT_TIME_MS = 2000
export const REVEAL_TIME_MS = 250
export const GAME_LOST_INFO_DELAY = 8 * REVEAL_TIME_MS
export const WELCOME_INFO_MODAL_MS = 350
